// iot-sensor-app/src/components/EditSensorCard.js
import React, { useState, useEffect, useRef } from 'react';
import {  Avatar, Container, Typography,Grid2, Paper, CssBaseline, Box, Button, TextField, ListItem, ListItemIcon, Dialog, DialogTitle, DialogContent, DialogActions, Snackbar} from '@mui/material';
import { FixedSizeList } from "react-window";
import SensorsIcon from '@mui/icons-material/Sensors';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import Co2Icon from '@mui/icons-material/Co2';
import InputAdornment from '@mui/material/InputAdornment';

const RenameDialogContent = ({id, oldName, setName, handleEditName}) => {
  return (
    <>
    <DialogContent> {/* 添加底部间距 */}
      <DialogTitle style={{ marginTop: '0px', marginBottom: '16px', textAlign: 'center' }}> RENAME <br/> MAC: {id.toUpperCase()} <br/> Current Name : {oldName}</DialogTitle> {/* 添加文本居中对齐 */}
        <TextField
          label="Edit Name"
          variant="outlined"
          onChange={(e) => setName(e.target.value)}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
      <Button variant="contained" onClick={handleEditName} style={{ margin: '0 auto' }}>Save</Button>
    </DialogActions>
    </>
  );
};

const DeleteDialogContent = ({id, oldName, handleDeleteSensor}) => {

  return (
    <>
    <DialogContent> {/* 添加底部间距 */}
      <DialogTitle style={{ marginTop: '0px', marginBottom: '16px', textAlign: 'center' }}> DELETE <br/> MAC: {id.toUpperCase()} <br/> Current Name : {oldName}</DialogTitle> {/* 添加文本居中对齐 */}
      <Typography style={{ textAlign: 'center' ,color: 'red'}}>Are you sure to delete this sensor?</Typography>
      </DialogContent>
      <DialogActions>
      <Button variant="contained" onClick={handleDeleteSensor} style={{ margin: '0 auto' }}>Confirm</Button> {/* 添加样式以居中按钮 */}
    </DialogActions>
    </>
  );
};

const handleUpdateCo2CalibrationEnable = async (id, enable) => {
  const response_enable = await fetch('/api/sensor/update_CO2_CAL_enable', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: id, enable:enable}),
  });
}

const handleUpdateCo2CalibrationValue = async (id, value) => {
  const response_value = await fetch('/api/sensor/update_CO2_CAL_value', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: id, value: value}),
  });
}

const Row = ({ data, style, setOpen, id, setId, setOldName, setDeleteOpen, setIsLoaded}) => {
  const [CO2CAL, setCO2CAL] = useState(data['CO2_CAL'] ? JSON.parse(data['CO2_CAL']) : null);
  const [CO2CAL_enable, setCO2CAL_enable] = useState(CO2CAL ? CO2CAL.enable : false);
  const [CO2CAL_value, setCO2CAL_value] = useState(CO2CAL ? CO2CAL.value : 0);

  const [TEMPCAL, setTEMPCAL] = useState(data['TEMP_CAL'] ? JSON.parse(data['TEMP_CAL']) : null);
  const [TEMPCAL_enable, setTEMPCAL_enable] = useState(data['TEMP_CAL_enable'] ? JSON.parse(data['TEMP_CAL_enable']) : null);  
  const [TEMPCAL_value, setTEMPCAL_value] = useState(data['TEMP_CAL_value'] ? JSON.parse(data['TEMP_CAL_value']) : null);

    return (
      <div style={style}>
        <ListItem >
          <Paper elevation={2} style={{ borderRadius: '8px', padding: '8px', minWidth: '100%' }}> 
            <Grid2 container alignItems="center" spacing={1}>
              <Grid2 item >
                <ListItemIcon>
                  <Avatar variant="rounded" style={{ backgroundColor: '#009999' }}>
                    {data['type'] == 'sensor' && <SensorsIcon />}
                    {data['type'] == 'aqmesh' && <FmdGoodIcon />}
                  </Avatar>
                </ListItemIcon>
              </Grid2>
              <Grid2 item size={2}>
                <Typography 
                  variant="h6" 
                  style={{ color: 'primary', fontSize: '16px'}}
                >
                  {data['deviceId'].toUpperCase()}
                </Typography>
              </Grid2>
              
              <Grid2 item size="grow" >
                <Typography 
                  variant="h6"
                  style={{ color: 'primary', fontSize: '16px'}}
                >
                  {data['name'] ? data['name'].toUpperCase() : 'null'}
                </Typography>
              </Grid2>

              <Grid2 item size={1.5}>
              <Typography 
                  variant="h6"
                  style={{ color: 'primary', fontSize: '16px'}}
                >
                  {data?.SCD ? `CO2: ${JSON.parse(data['SCD'])['3']}` : 'null'}
                </Typography>
              </Grid2>

              <Grid2 item xs={1} >
                <IconButton color="inherit" onClick={() => {handleUpdateCo2CalibrationEnable(id, !CO2CAL_enable);setIsLoaded(false)}}>
                  <Co2Icon 
                    style={{ color: (CO2CAL_enable) ? 'green' : 'red' }}
                  />
                </IconButton>
              </Grid2>
              
                <Grid2 item size={2}>
                    <TextField
                    size="small"
                    variant="outlined"
                    value={CO2CAL_value}
                    onChange={(e) => setCO2CAL_value(e.target.value)}
                    InputProps={{
                      endAdornment:
                        <InputAdornment position="end">
                          {(CO2CAL_value === "") ? (
                            <IconButton onClick={() => setCO2CAL_value(CO2CAL?.value)}>
                              <RefreshIcon /> 
                            </IconButton>
                          ) : (CO2CAL_value !== CO2CAL?.value && CO2CAL_value !== 0) ? (
                            <IconButton onClick={() => { handleUpdateCo2CalibrationValue(id, CO2CAL_value); setIsLoaded(false); }}>
                              <CheckIcon />
                            </IconButton>
                          ) : null}
                        </InputAdornment>
                    }}
                    />
                </Grid2>

              <Grid2 item xs={1} >
                <IconButton color="inherit" onClick={() => {setOpen(true); setId(id); setOldName(data['name'])}}> {/* 打开模态框 */}
                  <EditIcon />
                </IconButton>
              </Grid2 >
              
              <Grid2 item xs={1} >
                <IconButton color="inherit" disabled={data['type'] === 'aqmesh'} onClick={() => {setDeleteOpen(true); setId(id); setOldName(data['name'])}}> {/* 打开模态框 */}
                  <DeleteIcon />
                </IconButton>
              </Grid2 >
            </Grid2>
          </Paper>
        </ListItem>
      </div>
    );
};


const EditSensor_v1 = () => {
  const [sensorData, setSensorData] = useState({});
  const [searchName, setSearchName] = useState("");
  const [open, setOpen] = useState(false); // 添加状态管理
  const [oldName, setOldName] = useState("");
  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const containerRef = useRef(null);

  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);

  const [isLoaded, setIsLoaded] = useState(false);

  const fetchLastRecord = async () => {
    try {
      const response = await fetch('/api/sensor/lastrecord');
      const data = await response.json();
      if (data.error){
        window.location.href = '/';
        return;
      }
      Object.entries(data).forEach(([sensorId, sensorData]) => {
        const currentTime = new Date(sensorData.timestamp).getTime();
        const SCDdata = sensorData.SCD ? JSON.parse(sensorData.SCD) : null;
        const SFAdata = sensorData.SFA ? JSON.parse(sensorData.SFA) : null;
        const SPSdata = sensorData.SPS ? JSON.parse(sensorData.SPS) : null;

        setSensorData(prevData => ({
          ...prevData,
          [sensorId]: { type: 'sensor', sps: SPSdata,scd: SCDdata, sfa: SFAdata, ...sensorData } // 更新 SPS 数据
        }));
      });
    } catch (error) {
      console.error('Error fetching last record:', error);
    }
    setIsLoaded(true);
  };

  const fetchAQMeshData = async () => {
    try {
      const response = await fetch('/api/aqmesh/lastrecord');
      const data = await response.json();
      if (data.error){
        window.location.href = '/';
        return;
      }
      Object.entries(data).forEach(([sensorId, sensorData]) => {
        const currentTime = new Date(sensorData.timestamp).getTime();
        const aqmeshData = sensorData.aqmesh ? JSON.parse(sensorData.aqmesh) : null;

        setSensorData(prevData => ({
          ...prevData,
          [sensorId]: { type: 'aqmesh', aqmesh: aqmeshData, ...sensorData } // 更新 SPS 数据
        }));
      });
    } catch (error) {
      console.error('Error fetching last record:', error);
    }
    setIsLoaded(true);
  };

  

  useEffect(() => {
    fetchLastRecord();
    fetchAQMeshData();
  }, [isLoaded]);

  const handleEditName = async () => {

    if(sensorData[id].type === 'aqmesh'){
      const response = await fetch('/api/aqmesh/edit_sensor_name', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: id, name: name }),
      });
      const result = await response.json();
    
      if (result.success){
        setSeverity("success");
        setSnackbarMessage(result.success);
      }else{
        setSeverity("error");
        setSnackbarMessage(result.error);
      }
      setSnackbarOpen(true); // 打开 Snackbar
      setOpen(false); // 关闭模态框
      setIsLoaded(prev => !prev);
    };

    if(sensorData[id].type === 'sensor'){
    const response = await fetch('/api/sensor/edit_sensor_name', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: id, name: name }),
      });
      const result = await response.json();
    
      if (result.success){
        setSeverity("success");
        setSnackbarMessage(result.success);
      }else{
        setSeverity("error");
        setSnackbarMessage(result.error);
      }
      setSnackbarOpen(true); // 打开 Snackbar
      setOpen(false); // 关闭模态框
      setIsLoaded(prev => !prev);
    }
  }

  const handleDeleteSensor = async () => {

    if(sensorData[id].type === 'aqmesh'){
      const response = await fetch('/api/aqmesh/delete_sensor', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: id , name: name}),
      });
      const result = await response.json();
      if (result.success){
        setSeverity("success");
        setSnackbarMessage(result.success);
      }else{
        setSeverity("error");
        setSnackbarMessage(result.error);
      }
      setSnackbarOpen(true); // 打开 Snackbar
      setDeleteOpen(false);
      setIsLoaded(false);
    }
    if(sensorData[id].type === 'sensor'){
      const response = await fetch('/api/sensor/delete_sensor', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: id , name: name}),
      });
      const result = await response.json();
      if (result.success){
        setSeverity("success");
        setSnackbarMessage(result.success);
      }else{
        setSeverity("error");
        setSnackbarMessage(result.error);
      }
      setSnackbarOpen(true); // 打开 Snackbar
      setDeleteOpen(false);
      setIsLoaded(false);
    }   
  }

  const filteredRecords = searchName 
    ? Object.entries(sensorData)
        .filter(([sensorId, data]) => (data.deviceId.includes(searchName)))
        .sort(([, a], [, b]) => a.name.localeCompare(b.name)).reverse() // 按名称排序
        : Object.entries(sensorData)
        .sort(([, a], [, b]) => {
          const nameA = a.name || ""; // 如果 a.name 为 null，则使用空字符串
          const nameB = b.name || ""; // 如果 b.name 为 null，则使用空字符串
          return nameA.localeCompare(nameB);
        }).reverse(); // 按名称排序

  return (
    <Container ref={containerRef}>
      <CssBaseline />
      <Box my={4} mx="auto" display="flex" flexDirection="column" justifyContent="center" alignItems="center" minWidth="60%" maxWidth="80%">
      <Typography variant="h4" style={{ marginBottom: '16px' }}>Edit Sensor</Typography> {/* 修改为 Dashboard 标题 */}
      <TextField
        label="Serach by MAC Address"
        value={searchName}
        onChange={(e) => setSearchName(e.target.value.toLowerCase())}
        fullWidth
        style={{ marginBottom: '16px' }} // 添加底部间距
        InputProps={{
          endAdornment: (
            searchName && (
            <InputAdornment position="end">
              <IconButton onClick={() => {setSearchName('')}}>
                <ClearIcon />
              </IconButton>
            </InputAdornment>
            )
          ),
        }}
      />

      <FixedSizeList
        height={375}
        itemSize={75} // 每个项的高度
        itemCount={filteredRecords.length} // 项的数量 + 1 for header
        width="100%" // 列表宽度
        onMouseDown={(e) => e.preventDefault()} // 禁用鼠标事件
        onMouseLeave={(e) => e.preventDefault()} // 禁用触摸事件
      >
        {({ index, style }) => {
          const [id, data] = filteredRecords[index]; // 获取传感器ID和数据
          return (
            <Row id={data['deviceId']} data={data} style={style} setOpen={() => setOpen(true)} key={id} setId={setId} setOldName={setOldName} setDeleteOpen={setDeleteOpen} setIsLoaded={setIsLoaded}/>
          );
        }}

      </FixedSizeList>
    </Box>
    <Dialog open={open} onClose={() => {setName(""); setOpen(false)}} fullWidth maxWidth="xs"> {/* 使用 Dialog 替代 Modal */}
        <RenameDialogContent id={id} oldName={oldName} setName={setName} handleEditName={handleEditName} />
    </Dialog>
    <Dialog open={deleteOpen} onClose={() => {setId(""); setDeleteOpen(false)}} fullWidth maxWidth="xs"> {/* 使用 Dialog 替代 Modal */}
        <DeleteDialogContent id={id} oldName={oldName} setName={setName} handleDeleteSensor={handleDeleteSensor} />
    </Dialog>
    <Snackbar
      open={snackbarOpen}
      autoHideDuration={2000}
      onClose={() => setSnackbarOpen(false)}
    >
      <Alert  variant="filled" onClose={() => setSnackbarOpen(false)} severity={severity} sx={{ width: '100%' }}>{snackbarMessage}</Alert>
    </Snackbar>
    </Container>
  );
};

export default EditSensor_v1;